<div class="d-inline-block">
  <img appDisableMultipleClickWithNoneEvent class="mx-4 cursor-pointer" i18n-title="@@app.download_bom_pdf" title="Download BOM pdf" alt="" src="/assets/images/pdf_icon.svg" (click)="onDownloadPDF()"/>
  <ng-container>
    <app-document-types
      #BOMDescription
      [isHidden]="true"
      [property]="isProjectBOM ? 'project_bom_with_price' : 'bom_with_price'"
    ></app-document-types>
    <app-document-types
      #BOMWithoutPriceDescription
      [isHidden]="true"
      [property]="isProjectBOM ? 'project_bom_without_price' : 'bom_without_price'"
    ></app-document-types>
  </ng-container>
  <img appDisableMultipleClickWithNoneEvent class="cursor-pointer icon-height mr-1" i18n-title="@@app.download_bom_excel" title="Download BOM excel" alt="" src="/assets/images/xlsx_small_icon.svg" (click)="onDownloadExcel()"/>
</div>
